module.exports = __webpack_public_path__ + "img/FE_A3_back_en.3a420c19.png";